import { useContext } from 'react';
import { NotificationCtx } from '../NotificationContext';

export function useNotifications() {
  return useContext(NotificationCtx);
}
